const userDateFormat = {
    day_month_year: 'DD/MM/YYYY',
    month_day_year: 'MM/DD/YYYY',
    year_month_day: 'YYYY/MM/DD'
} as const;

export default userDateFormat;
